import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CalendarView } from "./dCalendar/dcalendar";
import dateFormat from 'dateformat';
import * as S from './calendar.styles';
import { startDateSelector, endDateSelector, tripTypeSelector } from "../../common/redux/selector";
import useOutsideClick from '../../hooks/useOutsideClick';
import { getTodaysDate, isToday } from '../../config/utils';
import { gcHomeScreen, pushCtaOmniEvents } from "../../config/omni";
import { CTA_TYPE, getActionNameForOmniture } from "../../utils/omni-utils";
import { CABS_HOME_PAGE, CABS_LANDING_ROUTE, PICKUP_DATE_UPDATE, RETURN_DATE_UPDATE } from "../../utils/util-constants";

interface CalendarProps {
  toggleCalendar: (boolean) => void,
  isPickUp: boolean,
  invokedFor : string,
  isMulticity : boolean
  extraAction: () => void
}

const Calendar: React.FC<CalendarProps> = ({
  toggleCalendar,
  isPickUp = true,
  invokedFor = gcHomeScreen,
  isMulticity = false,
  extraAction = () => {}
})  => {
  const startDate = useSelector(startDateSelector);
  const endDate = useSelector(endDateSelector);
  const tripType = useSelector(tripTypeSelector);
  const dispatch = useDispatch();
  const calendarBlockRef = React.createRef();
  const newDate = isPickUp ? startDate : endDate;
  useOutsideClick(calendarBlockRef, () => {
    toggleCalendar('');
  });

  const dateOnClickHandler = (dateObj) => {
    const isTy = isToday(dateObj);
    pushCtaOmniEvents(getActionNameForOmniture(invokedFor, isPickUp ? PICKUP_DATE_UPDATE : RETURN_DATE_UPDATE), CTA_TYPE.HYPER_LINK, CABS_HOME_PAGE, CABS_LANDING_ROUTE)
    dispatch({
      type: isPickUp ? 'UPDATE_START_DATE' : 'UPDATE_END_DATE',
      date: isTy ? new Date() : dateObj
    });
    toggleCalendar('');
    extraAction();
  };

  const minSelectedEndDate = new Date(startDate.date);
  minSelectedEndDate.setHours(minSelectedEndDate.getHours() + 12);

  const todaysDate = isPickUp ? getTodaysDate() : (isMulticity || tripType.rf === "rt") ? minSelectedEndDate : startDate.date
  const maxDateAllowed = new Date();
  maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 3);
  return (
    <S.CalendarBlockOuterWrapper ref={calendarBlockRef}>
      <CalendarView
        dateConfigForMonthToBeDisplayed={newDate.date || todaysDate}
        minDateAllowed={todaysDate}
        maxDateAllowed={maxDateAllowed}
        renderDateItem={({ value, dateObj }) => {
          if (!value) {
            return (
              <li>
                <span></span>
              </li>
            );
          }
          let isValid = true;
          const styles = dateFormat(newDate.date, 'dmmyyyy') === dateFormat(dateObj, 'dmmyyyy') ?
            {
              backgroundColor: 'rgb(34, 118, 227)',
              borderRadius: '50%',
              overflow: 'hidden'
            } :
          {};
          dateObj.setHours(0, 0, 0, 0);
          todaysDate.setHours(0, 0, 0, 0);
          isValid = dateObj.getTime() >= todaysDate.getTime() && dateObj.getTime() < maxDateAllowed.getTime();
            return (
              <li
                className={
                  dateFormat(newDate.date, 'dmmyyyy') === dateFormat(dateObj, 'dmmyyyy')
                    ? 'selectedDate'
                    : ''
                }
                key={value + dateObj.getTime()}
                style={isValid ? {...styles, color: 'black'} : {...styles, opacity: '0.4', color: 'grey'}}
                onClick={() => isValid ? dateOnClickHandler(dateObj) : () => {}}
              >
                <span className={dateFormat(newDate.date, 'dmmyyyy') === dateFormat(dateObj, 'dmmyyyy') ? 'leftactive' : ''}>{value}</span>
              </li>
            );
        }}
      />
    </S.CalendarBlockOuterWrapper>
  );
};

export default Calendar;
